import type { Profile } from '../../types/Profile';

export const profileCZFeatureConfig: Profile = {
    version: 2,
};
